import React from "react";

const Dot = ({ top, left, onClick, idx }) => {
  return (
    <>
      <div
        className="pulsating-circle"
        style={{ top, left }}
        onClick={() => {
          onClick(idx);
        }}
      ></div>
    </>
  );
};

export default Dot;
